import Corner from './Corner';

export default Corner;
